module.exports = __webpack_public_path__ + "assets/img/teacher (8).0c6e893f.png";